export abstract class AbstractPostListLoadMore {

    protected $load_more: JQuery;

    protected $load_more_label: JQuery;

    readonly $load_more_container:JQuery;

    readonly loading_more_label: string;

    readonly load_more_label: string;

    protected constructor(elem: HTMLElement) {
        this.$load_more = $(elem).find('.js-load-more');
        this.$load_more_label = this.$load_more.find('.js-load-more-button');
        this.loading_more_label = this.$load_more_label.data('loading_more_label');
        this.$load_more_container = $(elem).find('.js-load-more-container');
        this.load_more_label = this.$load_more_label.text();
    }

    protected handleLoading = () => {
        this.$load_more.addClass('c-load-more--disabled');
        this.$load_more.attr('disabled', 'disabled');
        this.$load_more.addClass('u-btn--load-more-is-loading');
        this.$load_more_container.addClass('c-actions--submitting');
        this.$load_more_label.text(this.loading_more_label);
    }

    protected handleLoaded = (hasMore: boolean) => {
        this.$load_more_container.removeClass('c-actions--submitting');
        if (!hasMore) {
            this.$load_more.addClass('u-btn-hide');
            this.$load_more.hide();
        } else {
            this.$load_more.removeClass('u-btn-hide');
            this.$load_more.removeAttr('disabled');
            this.$load_more.removeClass('u-btn--load-more-is-loading');
            this.$load_more.removeClass('c-load-more--disabled');
            this.$load_more.show();
            this.$load_more_label.text(this.load_more_label);
        }
    }
}